import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadOutlined } from '@ant-design/icons';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { PRODUCT } from '../../../constants/define/translation';

interface ProductPageHeaderProps {
  onGetEcomProduct?: () => void;
  extraDropdown?: any;
}

export const ProductPageHeader = (props: ProductPageHeaderProps) => {
  const { t } = useTranslation(PRODUCT);
  const { onGetEcomProduct, extraDropdown } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.button.update'),
      bgWhite: 'true',
      onClick: onGetEcomProduct,
      icon: <DownloadOutlined />,
    },
  ];

  return <ContentPageHeader title={t('title.product')} extra={extra} extraDropdown={extraDropdown} />;
};
